export default __webpack_public_path__ + "images/2e27983556c064883a94ddb9bffafcc2-toronto_desktop.webp";